import { render, staticRenderFns } from "./RegisterNewManager.vue?vue&type=template&id=395b7b6d"
import script from "./RegisterNewManager.vue?vue&type=script&lang=js"
export * from "./RegisterNewManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports